import React from 'react'
import { Container, Row, Col } from 'styled-bootstrap-grid'
import { Alert, Text } from 'mf-ui-components'

import rawlang, * as l10n from '../../../../utils/l10n'

const lang = rawlang as 'it' | 'en'

const Error = () => (
  <Container>
    <Row justifyContent="center">
      <Col col={10}>
        <Alert
          type="error"
          message={
            <Text el="p" styleName="label">
              {l10n.data_loading_error[lang]}
            </Text>
          }
        />
      </Col>
    </Row>
  </Container>
)

export default Error
